let modalTriggers;
let modalOverlays;
let modalCloseButtons;

function toggleModal(id) {
    const body = document.querySelector('body');
    const modal = document.querySelector(`[data-modal][id="${id}"]`);

    modal.classList.toggle('opacity-0');
    modal.classList.toggle('pointer-events-none');
    modal.setAttribute(
        'aria-hidden',
        modal.getAttribute('aria-hidden') === 'true' ? 'false' : 'true',
    );
    body.classList.toggle('modal-active');
}

function modalTriggerFunction(event) {
    event.preventDefault();
    let target = event.currentTarget.getAttribute('href');
    if (target.includes('#')) {
        target = event.currentTarget.getAttribute('href').substring(1);
    }

    toggleModal(target);
}

function modalCloseButtonFunction(event) {
    toggleModal(
        event.currentTarget.closest('[data-modal]').getAttribute('id'),
    );
}

function modalOverlayFunction(event) {
    toggleModal(
        event.currentTarget.closest('[data-modal]').getAttribute('id'),
    );
}

function keyDownFunction(event) {
    const isEscape = event.key === 'Escape' || event.key === 'Esc';
    if (isEscape && document.body.classList.contains('modal-active')) {
        toggleModal(
            document
                .querySelector('[data-modal][aria-hidden="false"]')
                .getAttribute('id'),
        );
    }
}

export default function initModals() {
    modalTriggers = document.querySelectorAll(
        "[data-modal-trigger], [href='#inspiration-form']",
    );
    modalTriggers.forEach((modalTrigger) => modalTrigger.removeEventListener('click', modalTriggerFunction));
    modalTriggers.forEach((modalTrigger) => modalTrigger.addEventListener('click', modalTriggerFunction));

    modalOverlays = document.querySelectorAll(
        '[data-modal] .modal-overlay',
    );
    modalOverlays.forEach((modalOverlay) => modalOverlay.removeEventListener('click', modalOverlayFunction));
    modalOverlays.forEach((modalOverlay) => modalOverlay.addEventListener('click', modalOverlayFunction));

    modalCloseButtons = document.querySelectorAll(
        '[data-modal] .modal-close',
    );
    modalCloseButtons.forEach((modalCloseButton) => modalCloseButton.removeEventListener('click', modalCloseButtonFunction));
    modalCloseButtons.forEach((modalCloseButton) => modalCloseButton.addEventListener('click', modalCloseButtonFunction));

    document.removeEventListener('keydown', keyDownFunction);
    document.addEventListener('keydown', keyDownFunction);
}
